import dayjs from 'dayjs';

import { longMonth } from 'src/common/helpers/DateFormatHelper';
import { DASHBOARD_LABELS } from 'src/common/labels/dashboard.labels';

export const getLastUpdatedText = (
	firstUpdatedAt: number,
	secondUpdatedAt: number
): string | null => {
	const latestTimestamp = Math.max(firstUpdatedAt, secondUpdatedAt);
	if (latestTimestamp === 0) {
		return null;
	}
	return `${DASHBOARD_LABELS.LAST_UPDATED}: ${dayjs(latestTimestamp).format(longMonth)}`;
};
